import styled from 'styled-components';

export const DealSelectionListStyled = styled.div`
  margin-top: 16px;
  .dealsSelectionList {
    &__row {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis; /
      &--id {
        font-size: 14px;
        font-family: ${props => props.theme.fontBold};
        color: ${props => props.theme.uiColors.multiFlightSectionTitleColor};
      }
        
      &--appAndSite, &--publisher {
        font-size: 14px;
        font-family: ${props => props.theme.fontRegular};
        color: ${props => props.theme.uiColors.multiFlightSectionDescriptionColor};
      }

      &--size, &--supplySource {
        font-size: 14px;
        font-family: ${props => props.theme.fontBold};
        color: ${props => props.theme.uiColors.multiFlightSectionDescriptionColor};
      }
    }
  }
`;
